import React from 'react';
import BarChartLoaderStyles from '../styles/barChartLoader';
import { useAppSelector } from '../../redux-store/hook';

export const BarChartLoader = (): JSX.Element => {
  const { settings } = useAppSelector((state) => state.template);
  const classes = BarChartLoaderStyles(settings);
  return (
    <div className={classes.barChartLoaderWrapper}>
      <div className={classes.barChartLoader}>
        <div>
          <div />
          <div />
          <div />
          <div />
        </div>
      </div>
    </div>
  );
};
